import locTypeCascader from "./index.vue";
export default locTypeCascader;
